import type { ID, PickActions } from '@core/ngrx-legacy';
import {
  createEntityCollectionStore,
  getEntityCollectionActions,
  pipeState,
} from '@core/ngrx-legacy';

export interface ViewCounter {
  id: ID;
  count: number;
}

const idSelector = (counter: { id: ID }) => counter.id;
const { actions, reducer, namespace, selectors } = createEntityCollectionStore<ViewCounter>()(
  'ViewCounters',
  {
    idSelector,
    customActions: adapter => {
      const defaultActions = getEntityCollectionActions(adapter, idSelector);
      return {
        fetchCollection: (state, payload: { dataSourceId: string; ids: ID[] }) =>
          defaultActions.fetchCollection(state, { scope: payload.dataSourceId }),
        fetchCollectionSuccess: (state, { scope, data }: { scope: string; data: ViewCounter[] }) =>
          pipeState(
            state,
            next => adapter.upsertMany(next, data, { scope }),
            next =>
              adapter.markAsLoaded(next, {
                scope,
                entities: data.map(c => c.id),
              }),
          ),
      };
    },
  },
);

const ViewCountersActions: PickActions<typeof actions, 'fetchCollection'> &
  Pick<typeof actions, 'updateOne'> = actions;

export {
  ViewCountersActions,
  reducer as ViewCountersReducer,
  namespace as ViewCountersNamespace,
  selectors as ViewCountersSelectors,
};
